import { canv } from '@/canv/global.js'

export class shapeMerge {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var k = height * width / (height + width);

        var allowedWidth = k;
        var allowedHeight = k - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + k/2 + textPart.lines[0].textHeight - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + 2*r, y); // 2*r потому что с просто r немного не правильно отображается угол
        canv.ctx.arcTo(x + width, y, x + width * 1/2, y + height, r);
        canv.ctx.arcTo(x + width * 1/2, y + height, x, y , r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    getAvatar(color) {
        return `
        <svg width="91" height="80" viewBox="0 0 91 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.4834 16.0158C-2.68399 8.93102 2.42414 0 10.6437 0H79.7554C87.9749 0 93.083 8.93102 88.9157 16.0158L54.3596 74.7607C50.2505 81.7464 40.1486 81.7464 36.0392 74.7607L1.4834 16.0158Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6023 20.4217L15.0332 20.6752L14.6023 20.4217C13.6592 22.0249 11.3408 22.0249 10.3977 20.4217L0.841206 4.17569C0.841205 4.17569 0.841204 4.17568 0.841203 4.17568C-0.115226 2.54969 1.05711 0.5 2.94353 0.5H22.0565C23.9429 0.5 25.1152 2.5497 24.1588 4.17569L14.6023 20.4217Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
